import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import { ToastProvider } from "./context/ToastContext";

import AdminNotifications from "./pages/AdminNotifications";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Learning from "./pages/Learning";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogsDetails";
import Jobs from "./pages/Jobs";
import NotFound from "./pages/NotFound";

import AdminLogin from "./admin/AdminLogin.js";
import Dashboard from "./admin/Dashboard";
import AdminBlogs from "./admin/AdminBlogs";
import ManageContacts from "./admin/ManageContacts";
import ContactInfo from "./admin/ContactInfo";
import AdminUsers from "./admin/AdminUsers.js";
import Ageret from "./pages/AgeretProductDetail";
import Azelite from "./pages/AzeliteProductDetail";
import NiaaSerum from "./pages/NiaaSerumProductDetail";
import Ceratina from "./pages/CeratinaProductDetail";
import RootInF from "./pages/RootInFProductDetail";
import RootIn from "./pages/RootInProductDetail";
import RootIn2 from "./pages/RootIn2.5ProductDetail";
import RootIn1 from "./pages/RootIn1.5ProductDetail.jsx";
import Mesojet from "./pages/MesojetProductDetail";
import UM150A from "./pages/UM150AProductDetail";
import HYdewPM from "./pages/HydewPMProductDetail";
import HydewFace from "./pages/HydewFaceProductDetail";
import Cutam from "./pages/CutamProductDetail";
import AngelDew from "./pages/AngelDewProductDetail";
import HydewBodyLotion from "./pages/HydewBodyLotionProductDetail";
import Melaact2 from "./pages/Melaact2ProductDetail.jsx";
import Sebosal from "./pages/SebosalProductDetail.jsx";
import Seblok5 from "./pages/Seblok5ProductDetail.jsx";
import Seblok10 from "./pages/Seblok10ProductDetail.jsx";
import Seblok20 from "./pages/Seblok20ProductDetail.jsx";
import Cumax from "./pages/CumaxProductDetail.jsx";
import Longy from "./pages/LongyProductDetail.jsx";
import BioUV32 from "./pages/BioUV32ProductDetail.jsx";
import BioUV50 from "./pages/BioUV50ProductDetail.jsx";
import BioUVFluid from "./pages/BioUVFluidProductDetail.jsx";
import BioUVMineral from "./pages/BioUVMineralProductDetail.jsx";
import BioUV50Spray from "./pages/BioUV50SprayProductDetail.jsx";
import SoraLite from "./pages/SoraLiteProductDetail.jsx";
import Estaar from "./pages/eStaarProductDetail.jsx";
import Pesklo from "./pages/PeskloProductDetail.jsx";
import CueON from "./pages/CueONProductDetail.jsx";
import Tazdone from "./pages/TazdoneProductDetail.jsx";
import Imulimus from "./pages/ImulimusProductDetail.jsx";
import ItzBio65 from "./pages/ItzBio65ProductDetail.jsx";
import ItzBio130 from "./pages/ItzBio130ProductDetail.jsx";
import DonationBbogs from "./pages/DonationBlogs";
import HairCareProducts from "./pages/HairCareProducts";
import MedicalEnggProducts from "./pages/MedicalEnggProducts";
import SkinCareProducts from "./pages/SkinCareProducts";
import MariniProducts from "./pages/MariniProducts.jsx";
import MariniProductDetail from "./pages/MariniProductDetail.jsx";
import AllProducts from "./pages/AllProducts.jsx";
import JobsDetails from "./pages/JobsDetailsPage.jsx";
import EventDetails from "./pages/EventsDetails.js";
import ScrollToTop from "./components/ScrollToTop";
import AdminProfile from "./admin/AdminProfile";
import VisitorTracker from "./components/VisitorTracker";
import ResetPassword from "./pages/ResetPassword";


const App = () => {


  return (
    <ToastProvider>
      <Router>
        <ScrollToTop />
        <VisitorTracker />
        <Routes>
          {/* Public Pages with Layout */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/products" element={<Layout><Products /></Layout>} />
          <Route path="/events" element={<Layout><Events /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/learning" element={<Layout><Learning /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/blogs" element={<Layout><Blogs /></Layout>} />
          <Route path="/jobs" element={<Layout><Jobs /></Layout>} />
          <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
          <Route path="/donation-blogs" element={<Layout><DonationBbogs /></Layout>} />
          <Route path="/product/SkinCare/ageret" element={<Layout> <Ageret /> </Layout>} />
          <Route path="/product/SkinCare/azelite" element={<Layout> <Azelite /> </Layout>} />
          <Route path="/product/SkinCare/niaa-serum" element={<Layout> <NiaaSerum /> </Layout>} />
          <Route path="/product/HairCare/Ceratina" element={<Layout> <Ceratina /> </Layout>} />
          <Route path="/product/HairCare/rootinf" element={<Layout> <RootInF /> </Layout>} />
          <Route path="/product/HairCare/rootin" element={<Layout> <RootIn /> </Layout>} />
          <Route path="/product/HairCare/rootin2-5" element={<Layout> <RootIn2 /> </Layout>} />
          <Route path="/product/HairCare/rootin1-25" element={<Layout> <RootIn1 /> </Layout>} />
          <Route path="/product/Medical-Engineering/Mesojet" element={<Layout> <Mesojet /> </Layout>} />
          <Route path="/product/Medical-Engineering/UM150A" element={<Layout> <UM150A /> </Layout>} />
          <Route path="/product/SkinCare/Hydew-Face" element={<Layout> <HydewFace /></Layout>} />
          <Route path="/product/SkinCare/HYDewPM" element={<Layout> <HYdewPM /></Layout>} />
          <Route path="/product/SkinCare/hydewbodylotion" element={<Layout> <HydewBodyLotion /></Layout>} />
          <Route path="/product/SkinCare/cutam" element={<Layout> <Cutam /></Layout>} />
          <Route path="/product/SkinCare/angeldew" element={<Layout> <AngelDew /></Layout>} />
          <Route path="/product/SkinCare/Melaact2" element={<Layout> <Melaact2 /></Layout>} />
          <Route path="/product/SkinCare/Sebosal" element={<Layout> <Sebosal /></Layout>} />
          <Route path="/product/SkinCare/Seblok5" element={<Layout> <Seblok5 /></Layout>} />
          <Route path="/product/SkinCare/Seblok10" element={<Layout> <Seblok10 /></Layout>} />
          <Route path="/product/SkinCare/Seblok20" element={<Layout> <Seblok20 /></Layout>} />
          <Route path="/product/SkinCare/Cumax" element={<Layout> <Cumax /></Layout>} />
          <Route path="/product/SkinCare/Longy" element={<Layout> <Longy /></Layout>} />
          <Route path="/product/SkinCare/BioUV32" element={<Layout> <BioUV32 /></Layout>} />
          <Route path="/product/SkinCare/BioUV50" element={<Layout> <BioUV50 /></Layout>} />
          <Route path="/product/SkinCare/BioUVFluid" element={<Layout> <BioUVFluid /></Layout>} />
          <Route path="/product/SkinCare/BioUVMineral" element={<Layout> <BioUVMineral /></Layout>} />
          <Route path="/product/SkinCare/BioUV50Spray" element={<Layout> <BioUV50Spray /></Layout>} />
          <Route path="/product/SkinCare/SoraLite" element={<Layout> <SoraLite /></Layout>} />
          <Route path="/product/SkinCare/eStaar" element={<Layout> <Estaar /></Layout>} />
          <Route path="/product/SkinCare/Pesklo" element={<Layout> <Pesklo /></Layout>} />
          <Route path="/product/SkinCare/CueON" element={<Layout> <CueON /></Layout>} />
          <Route path="/product/SkinCare/Tazdone" element={<Layout> <Tazdone /></Layout>} />
          <Route path="/product/SkinCare/Imulimus" element={<Layout> <Imulimus /></Layout>} />
          <Route path="/product/SkinCare/ItzBio65" element={<Layout> <ItzBio65 /></Layout>} />
          <Route path="/product/SkinCare/ItzBio130" element={<Layout> <ItzBio130 /></Layout>} />
          <Route path="/HairCareProducts" element={<Layout> <HairCareProducts /></Layout>} />
          <Route path="/MedicalEnggProducts" element={<Layout> <MedicalEnggProducts /></Layout>} />
          <Route path="/Skin-Care-Products" element={<Layout> <SkinCareProducts /></Layout>} />
          <Route path="/MariniProducts" element={<Layout> <MariniProducts /></Layout>} />
          <Route path="/product/marini/:id" element={<Layout><MariniProductDetail /></Layout>} />
          <Route path="/AllProducts" element={<Layout> <AllProducts /></Layout>} />
          {/* <Route path="/JobsDetails" element={<Layout> <JobsDetails /></Layout>} /> */}
          <Route path="/JobsDetails/:jobId" element={<Layout><JobsDetails /></Layout>} />
          {/* <Route path="/EventsDetails" element={<Layout> <EventsDetails /></Layout>} /> */}
          <Route path="/events/:id" element={<Layout><EventDetails /> </Layout>} />


          {/* Admin Pages - No Layout */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/contact" element={<ManageContacts />} />
          <Route path="/admin/AdminBlogs" element={<AdminBlogs />} />
          <Route path="/admin/contact-info" element={<ContactInfo />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/admin/notifications" element={<AdminNotifications />} />
          <Route path="/admin/reset-password/:token" element={<ResetPassword />} />






          {/* Not Found Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
};

export default App;
